import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var VideoIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M21.439 18.828A1 1 0 0023 18V6a1 1 0 00-1.561-.828L18 7.003A3 3 0 0015 4H4a3 3 0 00-3 3v10a3 3 0 003 3h11a3 3 0 003-3l3.439 1.828zM21 7.386v9.228l-3.439-2.33A1 1 0 0016 15.11V17a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h11a1 1 0 011 1v1.889a1 1 0 001.561.828L21 7.386z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
VideoIcon.isCarinaIcon = true;
export default VideoIcon;
